import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=3d47245c&scoped=true&"
import script from "./SelectCustomer.vue?vue&type=script&lang=ts&"
export * from "./SelectCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d47245c",
  null
  
)

export default component.exports